<template>
    <q-form class="q-gutter-md" @submit="onSubmit">
        <!-- <h3 class="text-login">{{ browserName }}</h3> -->
        <div class="col-12">
            <q-input v-model="formData.username"
                label-slot lazy-rules
                :rules="[ val => val && val.length > 0 || 'กรุณาป้อนรหัสพนักงาน' ]"
                filled dense>
                <template v-slot:label>
                    <span>รหัสพนักงาน</span>
                    <span style="color: red;"> *</span>
                </template>
            </q-input>
        </div>
        <div class="col-12">
            <q-input v-model="formData.password"
                label-slot lazy-rules
                :type="isPwd ? 'password' : 'text'"
                :rules="[ val => val && val.length > 0 || 'กรุณาป้อนรหัสผ่าน' ]"
                hint="รหัสผ่านเดียวกับระบบ ESS"
                filled dense>
                <template v-slot:label>
                    <span>รหัสผ่าน</span>
                    <span style="color: red;"> *</span>
                </template>
                <template v-slot:append>
                <q-icon
                    :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                />
                </template>
            </q-input>
        </div>
        
        <div class="col-12" style="padding-top: 8px;">
            <q-btn label="เข้าสู่ระบบ" type="submit" color="primary" :disable="isnotSupport" style="width: 100%;" />
            <div v-if="isnotSupport" class="text-bold" style="color: red;word-wrap: break-word;margin-top: 12px;">
              <span>Your Browser : {{ browserName }} version : {{ browserVersion }} is not support.</span><br>
              <span>Please update your browser or use other browser Chrome, Firefox, Opera</span>
            </div>
        </div>
        <div class="col-12" style="align-items: center; justify-content: right; display: flex;">
            <div class="rpwd text-caption" @click="resetPassword">Reset Password</div>
        </div>
        <div v-if="loginError" class="col-12 error-message">{{ loginError }}</div>
    </q-form>
</template>

<script lang="ts">
import { ref } from "vue";
import { axios, $http } from "@/boot/http";
import store from "@/store";
import route from "@/router";
import { QSpinnerIos, useQuasar } from "quasar";

export default {
    name: "LoginForm",
    setup() {
        const formData = ref({username: '',password: ''})
        const isPwd = ref(true)
        const loginError = ref('')
        const $q = useQuasar();
        const $httpClient = axios.create({
            baseURL: process.env.VUE_APP_SERVICE,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST, PUT, GET, OPTIONS, DELETE',
                'Access-Control-Allow-Headers': '*',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache'
            }
        })
        const onSubmit = async () => {
            $q.loading.show({
                message: '<span class="text-amber text-italic" style="font-size: 24px;">Please wait...</span>',
                spinner: QSpinnerIos,
                spinnerSize: 200,
                spinnerColor: 'amber',
                html: true
            })
            $httpClient.post('/api/auth/login', formData.value)
                .then(async (resp: any) => {
                    $q.loading.hide()
                    let data = resp.data != null ? resp.data : {}
                    if (data.redirectUrl == "" || data.redirectUrl == null) {
                        store.dispatch('setIsAutherized', true)
                        store.dispatch('setTokenKey', data.token )
                        store.dispatch('setCurrentLocale', 'th')
                        store.dispatch('setUserLogin', data)
                        let userInfo = await $http.get('/api/auth/getUser')
                        store.dispatch('setUserInfo', userInfo.data || {})
                        let permission = await $http.get('/api/auth/getPermissions')
                        store.dispatch('setPermission', permission.data || [])
                        route.push('/home')
                    } else {
                        location.href = data.redirectUrl
                    }
                })
                .catch((error: any) => {
                    $q.loading.hide()
                    let data = error.response.data != null ? error.response.data : {}
                    loginError.value = data.message
                })
        }
        const resetPassword = async () => {
            if (formData.value.username != "" || formData.value.username) {
                $httpClient.post('/api/auth/resetPassword', formData.value.username)
                    .then(async (resp: any) => {
                        let data = resp.data != null ? resp.data : {}
                        if (data.resultCode == '0000') {
                            location.href = data.url
                        } else {
                            loginError.value = data.msgTh
                        }
                })
                .catch((error: any) => {
                    let data = error.response.data != null ? error.response.data : {}
                    loginError.value = data.message
                })
            } else{
                loginError.value = 'กรุณาป้อนรหัสพนักงาน'
            }
        }
        const userAgent = window.navigator.userAgent;
        const m = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        const browserName = m.length > 0 ? m[1] : "Unknown";
        const browserVersion = m.length > 0 ? Number(m[2]) : "N/A";
        let isnotSupport = false
        // if (["Opera","Firefox","Chrome"].indexOf(browserName) > -1 ) {
        //     isnotSupport = false
        // } else {
        //     isnotSupport = true
        // }
        // if (browserName === "Chrome" && browserVersion != "N/A" && browserVersion < 100) {
        //     isnotSupport = true
        // }
        // if (browserName === "Firefox" && browserVersion != "N/A" && browserVersion < 100) {
        //     isnotSupport = true
        // }
        // if (browserName === "Opera" && browserVersion != "N/A" && browserVersion < 100) {
        //     isnotSupport = true
        // }
        return {
            formData,
            isPwd,
            onSubmit,
            resetPassword,
            loginError,
            browserName,
            browserVersion,
            isnotSupport
        }
    }
}
</script>

<style scoped>
.text-login {
    text-align: center;
    font: 40px "Helvetica Neue";
}
.error-message {
    text-align: center;
    font-size: 16px;
    color: red;
}
.rpwd {
    display: inline-block;
    cursor: pointer;
    color: rgb(0, 102, 255);
}
.rpwd:hover{
    color: rgb(0, 0, 176);
}
</style>